import Vue from 'vue'
import Router from 'vue-router'
// 平台路由
import ClassSpace from '@/views/platform/classspace/ClassSpace'
import WpsEdit from '@/views/platform/classspace/WpsEdit'
import Help from '@/views/platform/help/Help'
import Privacy from '@/views/platform/agreement/Privacy'
import WxtResource from "@/views/platform/resource/WxtResource";
import ZjwResource from "@/views/platform/resource/ZjwResource";
import StkResource from "@/views/platform/resource/StkResource";
import GuidePage from "@/views/platform/GuidePage";

import BkResource from '@/views/platform/resource/BkResource'

import TeacherHome from "@/views/platform/home/TeacherHome";

//移动端路由
import MobileHelp from '@/views/platform/help/MobileHelp'
import MobileTest from '@/views/mobile/Test'
import MobileUrlNav from '@/views/mobile/UrlNav'

Vue.use(Router)

const router = new Router({
    routes: [
        // 平台路由 start
        {
            path: '/guide/add-class',
            name: 'GuidePage',
            component: GuidePage
        },
        {
            path: '/teacher-home',
            name: 'TeacherHome',
            component: TeacherHome,
            meta: {
                title: '教学 - 首页'
            }
        },
        {
            path: '/platform/class-space',
            name: 'ClassSpace',
            component: ClassSpace,
            meta: {
                title: '班级资料'
            }
        },
        {
            path: '/platform/wps-edit/:id/:permission',
            name: 'WpsEdit',
            component: WpsEdit,
            meta: {
                title: '班级资料-在线编辑'
            }
        },
        {
            path: '/platform/help',
            name: 'Help',
            component: Help,
            meta: {
                title: '帮助中心',
                simple: true
            }
        },
        {
            path: '/tourists/agreement/:id',
            name: 'Privacy',
            component: Privacy,
            meta: {
                title: '协议中心',
                simple: true
            }
        },
        {
            path: '/source/wxt',
            name: 'WxtResource',
            component: WxtResource,
            meta: {
                title: '资源库'
            }
        },
        {
            path: '/source/wxt/:id', // 网校通和平台交互的地址：高度、详情页的传递
            name: 'WxtResource',
            component: WxtResource,
            meta: {
                title: '资源库'
            }
        },
        {
            path: '/source/zjw',
            name: 'ZjwResource',
            component: ZjwResource,
            meta: {
                title: '作业'
            }
        },
        {
            path: '/source/stk',
            name: 'StkResource',
            component: StkResource,
            meta: {
                title: '试题库'
            }
        },
        {
            path: '/source/bk',
            name: 'BkResource',
            component: BkResource,
            meta: {
                title: '备课'
            }
        },
        // 平台路由 end

        // 移动路由 start
        {
            path: '/platform/mobile/help',
            name: 'MobileHelp',
            component: MobileHelp,
            meta: {
                title: '帮助中心'
            }
        },
        {
            path: '/tourists/mobile/test',
            name: 'MobileTest',
            component: MobileTest,
            meta: {
                title: '移动端测试地址'
            }
        },
        {
            path: '/tourists/mobile/url/nav',
            name: 'MobileUrlNav',
            component: MobileUrlNav,
            meta: {
                title: '网址导航'
            }
        }
        // 移动端路由 end
    ]
})


router.beforeEach((to, from, next) => {
    if (to.meta.title) {
        document.title = 'e课堂 - ' + to.meta.title
    }
    if (location.href.indexOf('/wxt/agentsetting') !== -1) {
        console.log('wxt ', to.query.h)
    } else {
        next()
    }
})

const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return routerPush.call(this, location).catch(error => error)
}

export default router

